import { useState, useEffect, Fragment } from 'react'
import { formatDuration, formatLanguage, getVoiceName } from '../../utils/voiceUtils';

function AvatarGenerationModal({ onClose, onGenerate, voice, isLoading }) {
    const [avatarId, setAvatarId] = useState('');
    const [videoSize, setVideoSize] = useState('720p');
    const [error, setError] = useState('');

    // Reset form when modal opens with a new voice
    useEffect(() => {
        setAvatarId('');
        setVideoSize('720p');
        setError('');
    }, []);

    try {
        
        
        const handleSubmit = (e) => {
            e.preventDefault();
            
            if (!avatarId.trim()) {
                setError('請輸入 Avatar ID');
                return;
            }
            onGenerate(
                avatarId,
                videoSize,
                voice
            );
        };
        
        return (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50" data-name="avatar-generation-modal">
                <div className="bg-white rounded-xl w-full max-w-md shadow-2xl" data-name="modal-content">
                    <div className="p-6">
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-xl font-bold">生成數字人設定</h2>
                            <button 
                                onClick={onClose}
                                className="text-gray-400 hover:text-gray-600"
                                disabled={isLoading}
                                data-name="close-button"
                            >
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                        
                        {error && (
                            <div className="bg-red-50 border-l-4 border-red-400 p-4 mb-4 rounded" data-name="error-message">
                                <div className="flex">
                                    <i className="fas fa-exclamation-circle text-red-400 mr-3"></i>
                                    <p className="text-red-700">{error}</p>
                                </div>
                            </div>
                        )}
                        
                        {voice && (
                            <div className="bg-blue-50 p-3 rounded-lg mb-4">
                                <div className="font-medium">已選擇語音:</div>
                                <div className="flex justify-between items-center">
                                    <div>
                                        <div className="text-blue-700">{getVoiceName(voice.voice_id)}</div>
                                        { voice.extra_info?.audio_length && <div className="text-sm text-blue-500">{formatDuration(voice.extra_info?.audio_length)}</div> }
                                        <div className="text-sm text-blue-500">{formatLanguage(voice.language)}</div>
                                    </div>
                                    <div className="text-blue-700">
                                        <i className="fas fa-volume-up text-blue-400 mr-1"></i>
                                        {voice.speed}x
                                    </div>
                                </div>
                            </div>
                        )}
                        
                        <form onSubmit={handleSubmit}>
                            <div className="mb-4">
                                <label htmlFor="avatarId" className="block text-sm font-medium text-gray-700 mb-2">
                                    Avatar ID <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="avatarId"
                                    value={avatarId}
                                    onChange={(e) => {
                                        setAvatarId(e.target.value);
                                        setError('');
                                    }}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-purple-400"
                                    placeholder="輸入您的 HeyGen Avatar ID"
                                    disabled={isLoading}
                                    data-name="avatar-id-input"
                                />
                                <p className="mt-1 text-xs text-gray-500">
                                    您可以在 HeyGen 平台中找到您的 Avatar ID
                                </p>
                            </div>
                            
                            <div className="mb-6">
                                <label htmlFor="videoSize" className="block text-sm font-medium text-gray-700 mb-2">
                                    視頻尺寸
                                </label>
                                <select
                                    id="videoSize"
                                    value={videoSize}
                                    onChange={(e) => setVideoSize(e.target.value)}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-purple-400"
                                    disabled={isLoading}
                                    data-name="video-size-select"
                                >
                                    <option value="720p">720p (1280x720)</option>
                                    <option value="1080p">1080p (1920x1080)</option>
                                    <option value="square">Square (1080x1080)</option>
                                    <option value="portrait">Portrait (1080x1920)</option>
                                </select>
                            </div>
                            
                            <div className="mb-4 p-3 bg-yellow-50 border-l-4 border-yellow-400 rounded">
                                <div className="flex items-center">
                                    <i className="fas fa-coins text-yellow-500 mr-2"></i>
                                    <p className="text-yellow-700">此操作將消耗 2 點數</p>
                                </div>
                            </div>
                            
                            <div className="flex justify-end space-x-3">
                                <button
                                    type="button"
                                    onClick={onClose}
                                    className="px-4 py-2 border border-gray-300 text-gray-700 rounded hover:bg-gray-50"
                                    disabled={isLoading}
                                    data-name="cancel-button"
                                >
                                    取消
                                </button>
                                <button
                                    type="submit"
                                    className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700 flex items-center"
                                    disabled={isLoading}
                                    data-name="generate-button"
                                >
                                    {isLoading ? (
                                        <Fragment>
                                            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                                            生成中...
                                        </Fragment>
                                    ) : (
                                        <Fragment>
                                            <i className="fas fa-user-circle mr-2"></i>
                                            生成數字人
                                        </Fragment>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    } catch (error) {
        console.error('AvatarGenerationModal component error:', error);
        reportError(error);
        return null;
    }
}

export default AvatarGenerationModal;